import { StateUtils } from '@spartacus/core';
import { OccTrackingPickup } from '@tracking/const';
import { TRACKING_PICKUP } from '../tracking-state';

export const LOAD_TRACKING_PICKUP = '[Tracking] Tracking Pickup Load';
export const LOAD_TRACKING_PICKUP_SUCCESS = '[Tracking] Tracking Pickup Load Success';
export const LOAD_TRACKING_PICKUP_FAIL = '[Tracking] Tracking Pickup Load Fail';
export const TRACKING_PICKUP_RESET = '[Tracking] Tracking Pickup Reset';

export class TrackingPickupLoad extends StateUtils.EntityLoadAction {
  readonly type = LOAD_TRACKING_PICKUP;

  constructor(public orderGuid: string) {
    super(TRACKING_PICKUP, orderGuid);
  }
}

export class TrackingPickupLoadFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_TRACKING_PICKUP_FAIL;

  constructor(
    public orderGuid: string,
    public payload: any,
  ) {
    super(TRACKING_PICKUP, orderGuid, payload);
  }
}

export class TrackingPickupLoadSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_TRACKING_PICKUP_SUCCESS;

  constructor(
    public orderGuid: string,
    public payload: OccTrackingPickup,
  ) {
    super(TRACKING_PICKUP, orderGuid, payload);
  }
}

export class TrackingPickupReset extends StateUtils.EntityLoaderResetAction {
  readonly type = TRACKING_PICKUP_RESET;

  constructor(public orderGuid: string) {
    super(TRACKING_PICKUP, orderGuid);
  }
}
